import { motion } from 'framer-motion';
import { fadeUp, EASING } from '../constants/theme';

function NetworkVisual() {
  const nodes = [
    { cx: 160, cy: 80,  r: 8 },
    { cx: 260, cy: 50,  r: 6 },
    { cx: 310, cy: 140, r: 10 },
    { cx: 200, cy: 180, r: 7 },
    { cx: 100, cy: 170, r: 6 },
    { cx: 80,  cy: 270, r: 9 },
    { cx: 200, cy: 290, r: 7 },
    { cx: 300, cy: 260, r: 6 },
    { cx: 350, cy: 170, r: 5 },
    { cx: 240, cy: 200, r: 12 },
    { cx: 130, cy: 240, r: 5 },
  ];
  const edges = [
    [0,1],[0,3],[1,2],[2,3],[2,8],[3,4],[3,9],[4,5],[5,6],[5,10],[6,7],[6,9],[7,8],[8,9],[9,10],[10,6],
  ];
  return (
    <svg viewBox="0 0 400 340" fill="none" style={{ width: '100%', maxWidth: 420, height: 'auto' }}>
      {edges.map(([a, b], i) => (
        <motion.line
          key={i}
          x1={nodes[a].cx} y1={nodes[a].cy} x2={nodes[b].cx} y2={nodes[b].cy}
          stroke="rgba(255,255,255,0.22)" strokeWidth="1.5"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: [0.12, 0.32, 0.12] }}
          transition={{
            pathLength: { duration: 0.6, delay: 0.6 + i * 0.04, ease: 'easeOut' },
            opacity: { duration: 3 + (i % 4) * 0.7, repeat: Infinity, ease: 'easeInOut', delay: i * 0.18 },
          }}
        />
      ))}
      {nodes.map((n, i) => (
        <motion.circle
          key={i}
          cx={n.cx} cy={n.cy} r={n.r}
          fill={i === 9 ? '#3B88A9' : 'rgba(255,255,255,0.18)'}
          stroke={i === 9 ? '#fff' : 'rgba(255,255,255,0.5)'}
          strokeWidth={i === 9 ? 2.5 : 1.5}
          initial={{ scale: 0, opacity: 0 }}
          animate={{
            scale: 1,
            opacity: i === 9 ? 1 : [0.55, 1, 0.55],
            y: [0, i % 2 === 0 ? -5 : 5, 0],
          }}
          transition={{
            scale:   { duration: 0.4, delay: 0.4 + i * 0.06, ease: EASING.spring },
            opacity: { duration: 2.5 + (i % 3) * 0.8, repeat: Infinity, ease: 'easeInOut', delay: i * 0.22 },
            y:       { duration: 3 + (i % 4) * 0.5, repeat: Infinity, ease: 'easeInOut', delay: i * 0.15 },
          }}
        />
      ))}
      <motion.circle cx={240} cy={200} r={22} fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="1.5"
        animate={{ r: [22, 38, 22], opacity: [0.6, 0, 0.6] }}
        transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.circle cx={240} cy={200} r={22} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1"
        animate={{ r: [22, 50, 22], opacity: [0.4, 0, 0.4] }}
        transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut', delay: 0.5 }}
      />
    </svg>
  );
}

export default function Hero() {
  return (
    <section id="home" style={{ background: '#479EC3', paddingTop: 70, position: 'relative', overflow: 'hidden', height: '100vh', display: 'flex', flexDirection: 'column' }}>

      <div style={{
        position: 'absolute', inset: 0, zIndex: 0, pointerEvents: 'none',
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.05) 1px,transparent 1px)',
        backgroundSize: '64px 64px',
        maskImage: 'radial-gradient(ellipse 100% 80% at 50% 0%,black 50%,transparent 100%)',
        WebkitMaskImage: 'radial-gradient(ellipse 100% 80% at 50% 0%,black 50%,transparent 100%)',
      }}/>

      <motion.div animate={{ scale:[1,1.1,1], opacity:[0.3,0.45,0.3] }} transition={{ duration:9, repeat:Infinity }}
        style={{ position:'absolute', top:'-10%', right:'5%', width:500, height:500,
          background:'radial-gradient(ellipse,rgba(255,255,255,0.14) 0%,transparent 70%)',
          pointerEvents:'none', zIndex:0 }}/>

      <div className="container" style={{ position: 'relative', zIndex: 1, flex: 1, display: 'flex', alignItems: 'center' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          gap: 48, alignItems: 'center', width: '100%',
          paddingTop: 40, paddingBottom: 40,
        }} className="hero-grid">

          <div>
            <motion.div {...fadeUp(0.1)}>
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: 7,
                fontSize: 12, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase',
                color: 'rgba(255,255,255,0.9)', background: 'rgba(255,255,255,0.15)',
                border: '1px solid rgba(255,255,255,0.3)', borderRadius: 100,
                padding: '5px 14px', marginBottom: 24,
              }}>
                <svg width="6" height="6" viewBox="0 0 6 6"><circle cx="3" cy="3" r="3" fill="currentColor"/></svg>
                Next-Gen AI Solutions
              </span>
            </motion.div>

            <motion.h1 {...fadeUp(0.2)} style={{
              fontSize: 'clamp(36px, 4.5vw, 64px)',
              fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 1.06,
              color: '#fff', marginBottom: 22,
            }}>
              Reano{' '}
              <span style={{ color: 'transparent', WebkitTextStroke: '2px rgba(255,255,255,0.9)' }}>AI</span>
              {' '}Technologies
            </motion.h1>

            <motion.p {...fadeUp(0.3)} style={{
              fontSize: 17, color: 'rgba(255,255,255,0.85)', lineHeight: 1.7,
              marginBottom: 40, maxWidth: 460,
            }}>
              The next gen AI solutions provider for automation, analytics, and intelligent product experiences.
            </motion.p>

            <motion.div {...fadeUp(0.4)}>
              <motion.a
                href="#contact"
                animate={{ scale: [1, 1.07, 1, 1.04, 1] }}
                transition={{ duration: 0.6, repeat: Infinity, repeatDelay: 1.4, ease: 'easeInOut' }}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: '#fff', color: '#479EC3',
                  fontSize: 15, fontWeight: 700, padding: '13px 28px', borderRadius: 10,
                  textDecoration: 'none', transition: 'background .2s, transform .15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background='#F0F4F8'; e.currentTarget.style.transform='translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.background='#fff'; e.currentTarget.style.transform='none'; }}
              >
                Get Started
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="2.2">
                  <path d="M2.5 7.5h10M8.5 3.5l4 4-4 4"/>
                </svg>
              </motion.a>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3, ease: EASING.spring }}
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            className="hero-visual"
          >
            <NetworkVisual />
          </motion.div>
        </div>
      </div>

      <style>{`
        @media (max-width: 760px) {
          .hero-grid   { grid-template-columns: 1fr !important; min-height: auto !important; }
          .hero-visual { display: none !important; }
        }
      `}</style>
    </section>
  );
}
